<template>
  <nav class="navbar is-white">
    <div class="container">
      <div class="navbar-brand">
        <a class="brand-text" href="/">
          <img class="navbar-brand-logo" src="/img/logo.svg" alt="PESCLE" />
        </a>
        <router-link
          v-if="isViewProjectName"
          :to="{ name: 'projectsList' }"
          class="navbar-item brand-text"
          >{{ projectName }}</router-link
        >
        <div
          class="navbar-burger burger"
          data-target="navMenu"
          @click="toggleBurger()"
          v-bind:class="{ 'is-active': burgerActive }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div v-if="errorCount > 0" class="error-badge">
          <span class="tag is-rounded is-danger ml-1">
            {{ errorCount }}
          </span>
        </div>
      </div>
      <div
        id="navMenu"
        class="navbar-menu"
        v-bind:class="{ 'is-active': menuActive }"
      >
        <div class="navbar-start"></div>

        <div
          class="navbar-item has-dropdown"
          v-bind:class="{ 'is-active': sadminActive }"
          v-if="userRole == 'admin'"
        >
          <a class="navbar-link" @click="openDropdown('sadmin')">
            Space
          </a>
          <div class="navbar-dropdown is-right">
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'projectCreate' }"
              class="navbar-item"
            >
              Create Project
            </router-link>
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'usersList' }"
              class="navbar-item"
            >
              User List
            </router-link>
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'devicesAllList' }"
              class="navbar-item"
            >
              Device List
            </router-link>
          </div>
        </div>

        <div
          class="navbar-item has-dropdown"
          v-bind:class="{ 'is-active': adminActive }"
          v-if="projectRole == 'admin'"
        >
          <a class="navbar-link" @click="openDropdown('admin')">
            Project
          </a>
          <div class="navbar-dropdown is-right">
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'devicesList', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Device Config
              <span v-if="errorCount > 0" class="tag is-rounded is-danger ml-1">
                {{ errorCount }}
              </span>
            </router-link>
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'projectsView', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Project Config
            </router-link>
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'csvDownload', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Download
            </router-link>
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'devicesSupport', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Support
            </router-link>
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'faq', params: { projectId: projectId } }"
              class="navbar-item"
            >
              FAQ
            </router-link>
          </div>
        </div>

        <div
          class="navbar-item has-dropdown"
          v-bind:class="{ 'is-active': userActive }"
        >
          <a class="navbar-link" @click="openDropdown('user')">
            Menu
          </a>
          <div class="navbar-dropdown is-right">
            <router-link
              v-if="projectId"
              @click="disableDropdown()"
              :to="{ name: 'dashboard', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Dashboard
            </router-link>
            <router-link
              v-if="projectId"
              @click="disableDropdown()"
              :to="{ name: 'dataList', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Data
            </router-link>
            <router-link
              v-if="projectId"
              @click="disableDropdown()"
              :to="{ name: 'eventsList', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Events
            </router-link>
            <router-link
              v-if="projectId"
              @click="disableDropdown()"
              :to="{ name: 'reportDialy', params: { projectId: projectId } }"
              class="navbar-item"
            >
              Report
            </router-link>
            <router-link
              @click="disableDropdown()"
              :to="{ name: 'projectsList' }"
              class="navbar-item"
            >
              Project
            </router-link>
            <a
              href="/help/ja/index.html"
              class="navbar-item"
              @click="disableDropdown()"
              target="_blank"
            >
              Help
            </a>
            <hr class="navbar-divider" />
            <router-link
              :to="{ name: 'profileView' }"
              class="navbar-item"
              @click="disableDropdown()"
            >
              Profile
            </router-link>
            <a class="navbar-item" @click="signOut">
              SignOut
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { Auth } from "aws-amplify";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();
    const userActive = ref(false);
    const adminActive = ref(false);
    const sadminActive = ref(false);
    const menuActive = ref(false);
    const burgerActive = ref(false);
    const projectId = computed(() => {
      // URLにprojectIdがあればそれを、なければstoreから取得する
      if (route.params.projectId) {
        return route.params.projectId;
      } else {
        return store.getters.projectId;
      }
    });
    const isViewProjectName = computed(() => !route.path.includes("movie"));

    // サインアウト処理
    const signOut = async () => {
      disableDropdown();
      store.commit("unsetAll");
      store.commit("setMessage", t("auth.signOut"));
      await Auth.signOut();
      router.replace({ name: "authSignIn" });
    };

    // ハンバーガーメニューの表示切り替え
    const toggleBurger = async () => {
      burgerActive.value = !burgerActive.value;
      menuActive.value = !menuActive.value;
    };

    // ドロップダウンメニューの表示切り替え
    const openDropdown = (menu) => {
      if (menu == "admin") {
        userActive.value = false;
        adminActive.value = !adminActive.value;
        sadminActive.value = false;
      } else if (menu == "sadmin") {
        userActive.value = false;
        adminActive.value = false;
        sadminActive.value = !sadminActive.value;
      } else {
        userActive.value = !userActive.value;
        adminActive.value = false;
        sadminActive.value = false;
      }
    };

    // ドロップダウンメニューの非表示
    const disableDropdown = () => {
      burgerActive.value = false;
      menuActive.value = false;
      sadminActive.value = false;
      adminActive.value = false;
      userActive.value = false;
    };

    // URLが変わったらドロップダウンを閉じる
    watch(
      () => route.path,
      () => {
        userActive.value = false;
        adminActive.value = false;
        sadminActive.value = false;
        burgerActive.value = false;
        menuActive.value = false;
      },
      { immediate: true }
    );

    return {
      signOut,
      openDropdown,
      disableDropdown,
      toggleBurger,
      projectId,
      userActive,
      adminActive,
      sadminActive,
      burgerActive,
      menuActive,
      isViewProjectName,
      projectName: computed(() => store.getters.projectName),
      projectRole: computed(() => store.getters.projectRole),
      userRole: computed(() => store.getters.userRole),
      errorCount: computed(() => store.getters.errorCount),
    };
  },
};
</script>
<style>
.error-badge {
  margin-left: -28px;
  margin-right: 8px;
}

@media screen and (min-width: 1024px) {
  .error-badge {
    display: none;
  }
}
</style>
